import React from 'react';
import './StockNewsWidget.css';
import { formatAdminDateTime } from '../../utils/datetime';

const formatDateTime = (dateString) => formatAdminDateTime(dateString, '');

const StockNewsWidget = ({ newsItems = [], loading = false }) => {
    const handleArticleClick = (item) => {
        if (item.url || item.link) {
            window.open(item.url || item.link, '_blank');
        }
    };

    const DEFAULT_IMG = require('../../assets/Newspaper.jpg');

    return (
        <div className="sa-news-widget">
            <div className="sd-section-header">
                <div className="sd-section-icon purple">
                    <span className="material-symbols-outlined">newspaper</span>
                </div>
                <h3 className="sd-section-title">News</h3>
            </div>

            <div className="sa-widget-body">
                <div className="sa-news-list">
                    {loading ? (
                        <p className="sa-news-loading">Loading latest news...</p>
                    ) : newsItems?.length > 0 ? (
                        newsItems.map((item, idx) => (
                            <div className="sa-news-item" key={item.news_id || idx} onClick={() => handleArticleClick(item)}>
                                <div className="sa-news-img" style={{ 
                                    backgroundImage: `url(${item.image_url || DEFAULT_IMG})`
                                }}></div>
                                <div className="sa-news-content">
                                    <p>{item.title || item.headline}</p>
                                    <span className="sa-news-time">{formatDateTime(item.published_at || item.publication_date || item.publishedDate || item.date)}</span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="sa-news-empty">No news available currently.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StockNewsWidget;
